import React from "react"
import { observer } from "mobx-react-lite"
import styled from "~/ui/styled"
import Message from "../message"
import { MessageProps } from "../message/message.props"

interface MessageListItemProps extends MessageProps {}

const ItemWrap = styled.div`
  width: 100%;
  box-sizing: border-box;
`

// MessageListItem 消息组件
const MessageListItem: React.FC<MessageListItemProps> = (props) => {
  const { message } = props
  // 订阅 sender / byMe，sender 修正后列表项会重渲染
  const senderId = message.sender?.id
  const byMe = message.byMe

  return (
    <ItemWrap data-sender-id={senderId} data-by-me={byMe}>
      <Message {...props} />
    </ItemWrap>
  )
}
export default observer(MessageListItem)
